import React from 'react'
import classnames from 'classnames'
import './styles.scss'

export default class Select extends React.Component {
  static defaultProps = {
    error: false,
  }
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selected: this.getDefaultSelection(this.props)
    };

    this.handleClick = this.handleClick.bind(this);
  }

  getDefaultSelection(props) {
    // If the user provides no options, or explicitly provides text to show
    // when no option has been selected, we don't select an option by default.
    // Otherwise, we select the first one.
    return !props.options.length || props.noSelectionText ? null : props.options[0];
  }

  handleClick(e) {
    const select = this.selectNode;

    // Clicks to <button>s in our select element could trigger a form submit
    // if the <Select> is in a form. Prevent that, but only if the click happened
    // within our component.
    if(select && select.contains(e.target)) {
      e.preventDefault();
    }

    // If the click happened outside our component, close it.
    else {
      this.setState({ isOpen: false });
    }
  }

  handleSelect(option) {
    this.setState({
      isOpen: false,
      selected: option
    }, () => {
      this.props.onSelect(option);
    })
  }

  componentDidMount() {
    typeof document !== "undefined" &&
      document.addEventListener('click', this.handleClick, false) // eslint-disable-line no-undef
  }

  componentWillUnmount() {
    typeof document !== "undefined" &&
      document.removeEventListener('click', this.handleClick) // eslint-disable-line no-undef
  }

  componentWillReceiveProps(nextProps) {
    if(!this.state.selected || !nextProps.options.some(it => it.id === this.state.selected.id)) {
      this.setState({
        selected: this.getDefaultSelection(nextProps)
      });
    }
  }

  render() {
    const options = this.props.options.filter(option => (
      this.state.selected ? option.id !== this.state.selected.id : true
    ))
    
    return (
      <div className={classnames('select', this.props.waitlist && "waitlist", {
        'select--open': this.state.isOpen,
        'select--as-form-control': this.props.asFormControl,
        'select--disabled': this.props.disabled
      }, this.props.waitlistClassName)} ref={node => { this.selectNode = node; }}>

        <button
          className={classnames('select__selected', this.props.waitlist && "waitlist-select", {'select__selected--placeholder': !this.state.selected}, {"error":this.props.error})}
          onClick={() => {
            if(!this.props.disabled) {
              this.setState({ isOpen: !this.state.isOpen })
            }
          }}
          onKeyPress={() => {
            if(!this.props.disabled) {
              this.setState({ isOpen: !this.state.isOpen })
            }
          }}>
          {this.state.selected ?
            this.state.selected.label :
            this.props.noSelectionText || "Select an option..."}
        </button>

        <div className='select__options'>
          {options.map(option => (
            <button
              className='select__option'
              onClick={() => this.handleSelect(option)}
              onKeyPress={() => this.handleSelect(option)}
              key={option.id}
            >
              {option.label}
            </button>
          ))}
          {options.length === 0 &&
            <span className="select__option">
              {this.props.noOptionsText || "No options available"}
            </span>}
        </div>
      </div>
    )
  }

}




// WEBPACK FOOTER //
// ./client/components/Select/index.js